import { IconWell } from '@playbooks/molecules/icons/icon-well';
import { Avatar, AvatarContent, AvatarDescription, AvatarImage } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';
import { cn } from '@playbooks/ui/lib/utils';

export const MetaAvatar = ({ icon, thumbnail, title, href, className = '' }) => {
	// Theme
	const classNames = {
		link: cn('group h-auto p-0', className),
		root: cn('flex-start gap-3', className),
	};

	// Render
	if (href) {
		return (
			<Link variant='ghost' href={href} className={classNames.link}>
				<Avatar className='flex-start gap-3'>
					{thumbnail ? <AvatarImage src={thumbnail} alt={title} size='xs' /> : <IconWell icon={icon} size='sm' />}
					<AvatarContent>
						<AvatarDescription className='group-hover:underline leading-none'>{title}</AvatarDescription>
					</AvatarContent>
				</Avatar>
			</Link>
		);
	}
	return (
		<Avatar className={classNames.root}>
			{thumbnail ? <AvatarImage src={thumbnail} alt={title} size='xs' /> : <IconWell icon={icon} size='sm' />}
			<AvatarContent>
				<AvatarDescription className='leading-none'>{title}</AvatarDescription>
			</AvatarContent>
		</Avatar>
	);
};
